import type { ReportDefinitionGroup, ReportDefinitionSummary } from './api';
import { ReportSchedule } from './report-schedule';

/** Um conjunto visto de cima: quantos clientes, quantos contatos e quando sai o próximo envio das linhas ligadas. */
export class ReportGroupOverview {
  constructor(
    readonly group: ReportDefinitionGroup,
    private readonly lines: ReportDefinitionSummary[],
  ) {}

  get clientCount(): number {
    return this.lines.length;
  }

  /** O mesmo contato em dois clientes conta uma vez: é uma pessoa recebendo. */
  get contactCount(): number {
    return new Set(this.lines.flatMap((line) => line.recipients.map((recipient) => recipient.hqCustomerId))).size;
  }

  nextSendLabel(from: Date): string {
    const sends = this.lines
      .filter((line) => line.status === 'active')
      .map((line) => new ReportSchedule(line.schedule).nextSend(from))
      .filter((send) => send !== null)
      .sort((first, second) => first.at.getTime() - second.at.getTime());
    const [first] = sends;
    return first?.label ?? 'Nenhum envio programado';
  }
}
